import * as React from 'react';
import * as styles from './styles.css';

import { UIHeading4, UIText2, Button } from '@cian/ui-kit';

import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';

export interface IOnbordingTooltipProps {
  top: number;
  left: number;
  onClose(): void;
  onClick(): void;
  title: string;
  description: string;
  nextButtonText: string;
}

export const OnbordingTooltip: React.FC<IOnbordingTooltipProps> = ({
  top,
  left,
  onClose,
  onClick,
  title,
  description,
  nextButtonText,
}) => {
  return (
    <div data-testid="OnbordingTooltip" className={styles['tooltip']} style={{ top, left }}>
      <button data-testid="OnbordingTooltip_Close" type="button" className={styles['close']} onClick={onClose}>
        <IconActionClose12 color="white_60" />
      </button>
      <div className={styles['title']}>
        <UIHeading4 color="text-inverted-default">{title}</UIHeading4>
      </div>
      <div className={styles['description']}>
        <UIText2 color="text-inverted-default">{description}</UIText2>
      </div>
      <Button theme="fill_white_primary" size="XS" onClick={onClick}>
        {nextButtonText}
      </Button>
    </div>
  );
};

OnbordingTooltip.displayName = 'OnbordingTooltip';
